const LocalStorageService = (function(){
    var _service;
    function _getService() {
        if(!_service) {
            _service = this;
            return _service
        }
        return _service
    }
    function _setToken(token) {
        localStorage.setItem('access_token', token);
    }
    function _getAccessToken() {
        return localStorage.getItem('access_token');
    }
    function _getRefreshToken() {
        return localStorage.getItem('refresh_token');
    }
    function _clearToken() {
        localStorage.removeItem('access_token');
    }
    function _getCurrentUser() {
        return localStorage.getItem('current_user');
    }
    function _setCurrentUser(userObj) {
        localStorage.setItem('current_user', userObj);
    }
    function _clearUser() {
        localStorage.removeItem('current_user');
    }
    return {
        getService : _getService,
        setToken : _setToken,
        getAccessToken : _getAccessToken,
        getRefreshToken : _getRefreshToken,
        clearToken : _clearToken,
        getCurrentUser: _getCurrentUser,
        setCurrentUser: _setCurrentUser,
        clearUser: _clearUser,
    }
})();
export default LocalStorageService;